'use strict';

import $ from 'jquery';
import Mustache from 'mustache';

window.turnaround = {
	original_values: [],
	focused_inputs: [],
	saving: false,
	disable_infinite_scroll: false,
	loaded_turnarounds: [],
	validityChanged: false
};

var error_messages = {
	date: {
		start_before_end: {
			msg: 'Please note, start time must be before end time',
			target: ['start', 'end']
		},
		start_time_missing: {
			msg: 'Please note, start time missing',
			target: ['start']
		},
		end_time_missing: {
			msg: 'Please note, end time missing',
			target: ['end']
		},
		time_difference: {
			msg: 'Please note, time difference over 12 hours',
			target: ['start', 'end']
		},
		before_after_flight: {
			msg: 'Please note, timestamps not between actual flight time',
			target: ['start', 'end']
		}
	}
};

function showNotification(msg) {
	var $notification = $('body > .notification');
	$notification.find('.notification-message').text(msg);
	$notification.removeClass('hidden');
	setTimeout(function() {
		$notification.addClass('hidden').find('.notification-message').empty();
	}, 10000);
}

var clientJSVersion = 1517382838099;

var ops = {
	_addZero: function(i) {
		if (i < 10) {
			i = '0' + i;
		}
		return i;
	},
	_returnTimeStamp: function(timestampValue) {
		var self = this;

		var date = new Date(),
			day = date.getDate(),
			month = date.getMonth() + 1,
			year = date.getFullYear(),
			hours = date.getHours(),
			minutes = date.getMinutes(),
			seconds = date.getSeconds();

		return year + '-' + self._addZero(month) + '-' + self._addZero(day) + 'T' + self._addZero(hours) + ':' + self._addZero(minutes) + ':' + self._addZero(seconds);
	},
	_headerActions: function() {
		// Hide header if scrolled down beyond header height
		// Always show the header if scrolled up

		var lastScrollTop = 0;

		$(window).scroll(function() {
			var st = $(this).scrollTop();

			if (st > lastScrollTop && st > 180){
				$('.ops-header').css('top', -180);
			} else if(st < lastScrollTop) {
				$('.ops-header').css('top', 0);
			}

			lastScrollTop = st;
		});
	},
	_collapseControls: function() {
		// Collapsing of the filter container

		$('.collapse-ops-controls').click(function(){
			if($('#ops-controls').is(':visible')){
				$(this).find('.text').text('Show controls');
			} else {
				$(this).find('.text').text('Hide controls');
			}
			$('#ops-controls').slideToggle(200);
		});

		if($('#ops-controls').is(':visible')){
			$('.collapse-ops-controls').find('.text').text('Hide controls');
		} else {
			$('.collapse-ops-controls').find('.text').text('Show controls');
		}
	},
	_updateUrlParameters: function(param, value) {
		// Update url parameter based on filters and currently shown turnarounds
		// Add new if doesn't exist and update if already exists

		const parameters = window.location.href.replace(window.location.origin + window.location.pathname, '');
		let newUrl = '';
		if(parameters.match(param)){
			const regExp = new RegExp(param + '(.+?)(&|$)', 'g');
			newUrl = window.location.href.replace(regExp, param + '=' + value + '$2');
		} else {
			const separator = parameters.match('\\?') ? '&' : '?';
			newUrl = parameters + separator + param + '=' + value;
		}
		window.history.pushState('', '', newUrl);
	},
	_getUrlParameters: function(name) {
		var url = location.href;
		name = name.replace(/[\[]/,'\\\[').replace(/[\]]/,'\\\]');
		var regexS = '[\\?&]'+name+'=([^&#]*)';
		var regex = new RegExp( regexS );
		var results = regex.exec( url );

		return results == null ? null : results[1];
	},
	_getTurnarounds: function(itemCount) {
		// Get turnaround data based on parameters

		var self = this;

		if(window.turnaround.disable_infinite_scroll === false){

			window.turnaround.disable_infinite_scroll = true;

			$('.error-container').hide();
			$('.row-loader').show();

			var apt = $('select[name=apt]').val();
			var date_min = $('input[type=date][name=min]').val();
			var date_max = $('input[type=date][name=max]').val();

			if(self._getUrlParameters('date_min')){
				date_min = self._getUrlParameters('date_min');
			}

			if(self._getUrlParameters('date_max')){
				date_max = self._getUrlParameters('date_max');
			}

			var template = document.getElementById('mustache-ops-row').innerHTML;
			$.ajax({
				url: '/stage-ajax/getTurnarounds/',
				type: 'GET',
				data: {
					apt: apt,
					show: itemCount ? itemCount : 0,
					date_min: date_min ? date_min : false,
					date_max: date_max ? date_max : false
				}
			})
			.done(function(result) {
				if(result.turnarounds.length > 0){
					if(result.duplicates && result.duplicates.length){
						console.log('%c This airport has ' + result.duplicates.length + ' duplicate turnarounds.', 'color: #C18922');
					} else if(result.duplicates && result.duplicates.length === 0) {
						console.log('%c This airport has no duplicate turnarounds.', 'color: #228252');
					}

					var output = Mustache.render(template, result);
					$('.turnaround-container .item-list').append(output);

					$('.row-loader').hide();
					self._updateUrlParameters('show', $('.turnaround-container .item-list .item').length);
					self._updateUrlParameters('apt', apt);
					if(date_min){ self._updateUrlParameters('date_min', date_min); }
					if(date_max){ self._updateUrlParameters('date_max', date_max); }

					window.turnaround.disable_infinite_scroll = false;
				} else {
					$('.row-loader-container .row-loader').fadeOut(400, function(){ $(this).remove(); });

					if(!$('.turnaround-container .item-list .item').length){
						$('.error-container').fadeIn(400);
						self._updateUrlParameters('apt', apt);
						if(date_min){ self._updateUrlParameters('date_min', date_min); }
						if(date_max){ self._updateUrlParameters('date_max', date_max); }
					}
					window.turnaround.disable_infinite_scroll = true;
				}
				self._itemActions();
				self._archive();

			});

		}
	},
	_loadRows: function() {
		// Load turnarounds if scrolled to the bottom of the page
		// Refresh turnaround list if filter inputs change

		var self = this;

		$(window).scroll(function(){
			if($('.row-loader-container').length && $(window).scrollTop() + $(window).height() >= $('.row-loader-container').offset().top){
				self._getTurnarounds($('.turnaround-container .item-list .item').length);
			}
		});

		function changeFilter(input) {
			if(input.is('input[type=date][name=min]')){ self._updateUrlParameters('date_min', input.val()); }
			if(input.is('input[type=date][name=max]')){ self._updateUrlParameters('date_max', input.val()); }
			if(input.is('select[name=apt]')){
				$('input[type=date][name=min]').val('');
				$('input[type=date][name=max]').val('');
				self._updateUrlParameters('date_min', '');
				self._updateUrlParameters('date_max', '');
			}

			if($(window).width() <= 680 || $(window).height() <= 520){
				$('#ops-controls').slideUp(200);
				$('.collapse-ops-controls .text').text('Show controls');
			}

			$('.item-list').html('');
			$('.row-loader-container').html('<div class="row-loader"><div></div><div></div><div></div><div></div></div>');

			window.turnaround.disable_infinite_scroll = false;

			self._getTurnarounds();
		}

		$('select[name=apt]').change(function() {
			changeFilter($(this));
		});

		$('input[type=date][name=min], input[type=date][name=max]').on('input', function() {
			var input_value = $(this).val();
			if(input_value.match(/^(?!0.)\d{4}\-\d{1,2}\-\d{1,2}$/, 'gi')){ // e.g. 2019-12-24
				input_value = input_value.replace(/(\d{4})\-(\d{1,2})\-(\d{1,2})$/g, '$1/$2/$3'); // -> 2019/12/24
			} else if(input_value.match(/\d{1,2}\.\d{1,2}\.\d{4}$/, 'gi')) { // e.g. 24.12.2019
				input_value = input_value.replace(/(\d{1,2})\.(\d{1,2})\.(\d{4})$/g, '$3/$2/$1'); // -> 2019/12/24
			} else {
				input_value = false;
			}
			if(Date.parse(input_value)){
				changeFilter($(this));
			}
		});
	},
	_showListEditFields: function(turnaround) {
		var $edit_fields = turnaround.find('.edit-field');

		$edit_fields.each(function(){
			var $table = $(this);

			$table.find('table tr:nth-of-type(0), table tr:nth-of-type(1)').addClass('show');

			$table.find('.show-next').click(function() {
				$table.find('table tr:hidden').first().show().addClass('show');

				if($table.find('table tr:hidden').length === 0){
					$(this).hide();
				}
			});
		});
	},
	_handleErrorIndicators: function(element, list_view){
		var $date = element.parent().find('input[type=date]');
		var $time = element.parent().find('input[type=time]');

		if($date.val() !== '' && $time.val() !== ''){
			element.parent().find('input.datetime').val($date.val() + ' ' + $time.val() + ':00');
			element.parent().find('input.datetime').attr('value', $date.val() + ' ' + $time.val() + ':00');
			element.parent().find('input.datetime').prop('value', $date.val() + ' ' + $time.val() + ':00');
		} else {
			//element.parent().find('input.datetime').val('');
		}

		// Timestamp error messages
		if(element.parent().hasClass('start') || element.parent().hasClass('end')){
			var $input = element;
			var $target = element;
			var $field = element.parents('.edit-field');
			var $target_parent = $field;

			var field_id = $($input.parents('.list-item').find('td[data-attribute]')[0]).data('attribute');
			var error_indicator_html = '<div id="' + (field_id ? field_id : '') + '" class="input-error-indicator"><div class="input-error-indicator-tooltip"></div><div class="input-error-indicator-tooltip-arrow"></div></div>';

			if(!$field.parent().find('#' + field_id).length){
				$field.before(error_indicator_html);
			}

			if(list_view) {
				$target = $target.parents('.ops-item-field').find('.extra-content td[data-attribute=' + field_id + ']');
				$target_parent = $target.parents('.extra-content');
			}

			var $error_indicator = $field.parent().find('#' + field_id);

			var start_input_value = $input.parents('.list-item').find('.timestamp-change.start .datetime').val();
			var end_input_value = $input.parents('.list-item').find('.timestamp-change.end .datetime').val();
			var start_time = start_input_value ? Date.parse(start_input_value) : false;
			var end_time = end_input_value ? Date.parse(end_input_value) : false;

			var dep_sdt = $input.parents('.item').data('depact') ? Date.parse($input.parents('.item').data('depact')) : false;
			var arr_sdt = $input.parents('.item').data('arract') ? Date.parse($input.parents('.item').data('arract')) : false;

			var tooltip_position = ($target.parents('tr').height() / 2) + ($target.parents('tr').offset().top - $target_parent.offset().top) - 8;

			function handleErrorMessage(message, required = false) {
				$field.parent().find('#' + field_id).fadeIn(200);

				$error_indicator.css('top', tooltip_position);
				$error_indicator.fadeIn(200);
				$error_indicator.find('.input-error-indicator-tooltip').text(message.msg);

				$.each(message.target, function(key, target) {
					$input.parents('.list-item').find('.' + target).addClass('time-error');

					if (required) {
						$input.parents('.list-item').find('.' + target).addClass('required');
					}

				});
			}

			if(!start_time && !end_time){
				$input.parents('.list-item').find('.start, .end').removeClass('time-error');
				$error_indicator.fadeOut(200, function(){
					$error_indicator.remove();
				});
			} else if(!start_time){
				handleErrorMessage(error_messages.date.start_time_missing);
			} else if(!end_time){
				handleErrorMessage(error_messages.date.end_time_missing);
			} else if(start_time > end_time){
				handleErrorMessage(error_messages.date.start_before_end);
			} else if((end_time - start_time) > 43200000){
				handleErrorMessage(error_messages.date.time_difference);
			} else if(dep_sdt && start_time > dep_sdt){
				handleErrorMessage(error_messages.date.before_after_flight);
			} else if(arr_sdt && start_time < arr_sdt){
				handleErrorMessage(error_messages.date.before_after_flight);
			} else if(dep_sdt && end_time > dep_sdt){
				handleErrorMessage(error_messages.date.before_after_flight);
			} else if(arr_sdt && end_time < arr_sdt){
				handleErrorMessage(error_messages.date.before_after_flight);
			} else {
				$input.parents('.list-item').find('.start, .end').removeClass('time-error');
				$error_indicator.fadeOut(200, function(){
					$error_indicator.remove();
				});
			}
		}
	},
	_getItemContent: function(turnaround_id, item) {
		// Get turnaround contents when clicked open

		var self = this;

		var template = document.getElementById('mustache-ops-content').innerHTML;
		$.ajax({
			url: '/stage-ajax/turnaroundContents/',
			type: 'GET',
			data: {
				turnaround_id: turnaround_id,
				airport: $('#ops-controls select[name=apt]').val() ? $('#ops-controls select[name=apt]').val() : ''
			}
		})
		.done(function(result) {
			window.turnaround.loaded_turnarounds[turnaround_id] = result.all_fields;
			item.find('.update-checker').remove();

			var output = Mustache.render(template, result);
			item.find('.item-content-item .contents').html(output);
			item.find('.item-content-loader').fadeOut(function(){ $(this).remove(); });
			item.find('.item-handle').attr('data-loaded', 'yes');
			item.find('.item-handle').data('loaded', 'yes');
			item.find('.item-refresher').remove();

			if(item.find('.item-handle').hasClass('active')){
				item.find('.item-content').slideDown();
			}

			// Allow radio buttons to be unselected
			$('input[type=radio]').siblings('label').click(function(e) {
				if($(this).prev('input[type=radio]').prop('checked')){
					e.preventDefault();
					$(this).prev('input[type=radio]').prop('checked', false);
				}
			});

			// Activate number decreasing/increasing buttons
			$('.increase-number[data-target], .decrease-number[data-target]').unbind().click(function(){
				var $target = $($(this).data('target'));
				var target_value = $target.val() ? parseInt($target.val()) : 0;

				if ($(this).hasClass('increase-number')) {
					$target.val(++target_value);
				} else {
					$target.val(--target_value);
				}
			});

			$('.edit-field input[type=date]').click(function () {
				var $input = $(this);
				if ($input.val() === '') {
					$input.val(self._returnTimeStamp().split('T')[0]);
				}
			});

			$('.edit-field input[type=time]').click(function () {
				var $input = $(this);

				if ($input.val() === '') {
					var date = new Date(),
						hours = date.getHours(),
						minutes = date.getMinutes();
					$input.val(self._addZero(hours) + ':' + self._addZero(minutes));
				}

				/*if ($input.prev().val() === '') {
					$input.prev().val(self._returnTimeStamp().split('T')[0]);
				}*/
			});

			/*$('.edit-field input[type=date], .edit-field input[type=time]').each(function(){
				var $self = $(this);
				if($self.siblings('input.datetime').val()){
					var $target = $self.parents('.ops-item-field').find('.attribute-current[data-uuid=' + $self.siblings('input.datetime').data('uuid') + ']');
					handleErrorIndicators($(this), $target);
				}
			});*/

			$('.edit-field input[type=date], .edit-field input[type=time]').each(function() {
				self._handleErrorIndicators($(this), true);
			});

			$('.edit-field input[type=date], .edit-field input[type=time]').on('input click blur', function(){
				self._handleErrorIndicators($(this));
			});

			$('.edit-field .start input[type=date], .edit-field .start input[type=time], .edit-field .end input[type=date], .edit-field .end input[type=time]').unbind('input').on('input', function(){});

			self._showListEditFields(item);
		});
	},
	_getItemObject: function(turnaround_id, item) {
		// Get turnaround contents when clicked open

		var self = this;

		var output = {};

		var template = document.getElementById('mustache-ops-content').innerHTML;
		$.ajax({
			url: '/stage-ajax/turnaroundContents/',
			type: 'GET',
			data: {
				turnaround_id: turnaround_id
			},
		})
		.done(function(result) {
			output = result.all_fields;
			var differences_found = false;

			$.each(output, function(k,v){
				if(JSON.stringify(v.value) != JSON.stringify(window.turnaround.loaded_turnarounds[turnaround_id][k].value)){
					differences_found = true;
				}
			});

			var $item = $('.item-handle[data-turnaround='+ turnaround_id +']').parent();
			$item.find('.update-checker').addClass('true');

			if(differences_found){
				$item.find('.item-content').append('<div class="item-refresher"><span class="refreshing-text">Data has changed. Fetching new data...</span><div class="lds-ripple"><div></div><div></div></div></div>');
				self._getItemContent($item.find('.item-handle').data('turnaround'), $item);
			} else {
				$item.find('.update-checker').text('Data is up-to-date.');
				setTimeout(function(){
					$item.find('.update-checker').remove();
				},6000);
			}
		});
	},
	_inputEdit: function(element, action) {
		// Handle turnaround input editing for saving and canceling

		action = action || false;

		if(action === 'clear') { // Clear the data of editing

			window.turnaround.original_values.length = 0;
			window.turnaround.focused_inputs.length = 0;

		} else if(element) {

			// Handling of the number input buttons
			if(element.hasClass('decrease-number') || element.hasClass('increase-number')){
				element = element.siblings('input[type=number]');
			}

			var type = 'text'

			if(element.prop('type') === 'number'){
				type = 'number';
			} else if(element.prop('type') === 'radio') {
				type = 'radio';
				element = element.next('label.radio-label');
			} else if((element.prop('type') === 'date' || element.prop('type') === 'time') || (element.attr('type') === 'date' || element.attr('type') === 'time')) {
				type = 'timestamp';
				element = element.parent().find('input[type=hidden]');
			} else if(element.parent().hasClass('select-field')) {
				type = 'select';
			} else if(element.hasClass('radio-label')) {
				type = 'radio';
			}

			var allow_input_adding = true;
			var i = 0;

			// Get original input values for canceling editing
			if(element.hasClass('radio-label')){

				for (i = 0; i < window.turnaround.focused_inputs.length; i++) {
					if(window.turnaround.focused_inputs[i].uuid === element.prev('input[type=radio]').data('uuid')){
						allow_input_adding = false;
					}
				}

				if(allow_input_adding || !window.turnaround.focused_inputs.length === 0){
					window.turnaround.original_values.push({
						uuid: element.prev('input[type=radio]').data('uuid'),
						value: $('input[name='+element.prev('input[type=radio]').prop('name')+']:checked').length ? $('input[name='+element.prev('input[type=radio]').prop('name')+']:checked').val() : undefined,
						type: type
					});
					window.turnaround.focused_inputs.push({ uuid: element.prev('input[type=radio]').data('uuid'), type: type });
				}

			} else if(element.hasClass('select')) {

				for (i = 0; i < window.turnaround.focused_inputs.length; i++) {
					if(window.turnaround.focused_inputs[i].uuid === element.data('uuid')){
						allow_input_adding = false;
					}
				}

				if(allow_input_adding || !window.turnaround.focused_inputs.length === 0){
					window.turnaround.original_values.push({
						uuid: element.data('uuid'),
						value: element.val(),
						type: type
					});
					window.turnaround.focused_inputs.push({ uuid: element.data('uuid'), type: type }); // For avoiding duplicate input objects
				}
			} else {

				for (i = 0; i < window.turnaround.focused_inputs.length; i++) {
					if(window.turnaround.focused_inputs[i].uuid === element.data('uuid')){
						allow_input_adding = false;
					}
				}

				if(allow_input_adding || !window.turnaround.focused_inputs.length === 0){
					window.turnaround.original_values.push({
						uuid: element.data('uuid'),
						value: element.val(),
						type: type
					});
					window.turnaround.focused_inputs.push({ uuid: element.data('uuid'), type: type }); // For avoiding duplicate input objects
				}
			}

		}

	},
	_saveEditedTurnaround: function(turnaround) {
		// Get turnaround contents when clicked open

		var self = this;

		var i = 0;

		var errors = false;

		if(turnaround.find('.time-error.required').length){
			errors = true;
			var error_position = $(turnaround.find('.time-error')[0]).parents('.edit-field').offset().top;
			$('html, body').stop().animate({ scrollTop: error_position }, 400, 'swing');
		}

		if(!errors){
			var turnaround_changes = [];
			var turnaround_id = turnaround.children('.item-handle').data('turnaround');
			var user_uuid = window.user.uuid;

			turnaround.removeClass('edit');

			if(window.turnaround.validityChanged === true){

				var validity = turnaround.find('.validity .edit-validity').attr('data-validity');

				$.ajax({
					url: '/stage-ajax/turnaroundSaveValidity/',
					type: 'GET',
					data: {
						turnaround_id: turnaround_id,
						invalid: validity
					},
				})
				.done(function(result) {

					if(validity == 'invalid'){
						turnaround.find('.validity').addClass('invalid');
						turnaround.find('.item-name .archive-container .archive-buttons').fadeIn(200);
					} else {
						turnaround.find('.validity').removeClass('invalid');

						if(!turnaround.find('.edit-field #field-actype').val()){
							turnaround.find('.item-name .archive-container .archive-buttons').fadeOut(200);
						}
					}
				})
				.fail(function(jqXHR, textStatus) {
					console.log('Error: Can\'t save validity value.');
				});

				window.turnaround.validityChanged = false;
			}

			// Update fields if values have changed
			var focused_inputs = window.turnaround.focused_inputs;
			for (i = 0; i < focused_inputs.length ;i++) {

				var changed_value = '';
				var entry_uuid = '';
				var attribute_id = '';

				if(focused_inputs[i]){
					if(focused_inputs[i].type === 'text' || focused_inputs[i].type === 'timestamp'){
						if(turnaround.find('.edit-field textarea[data-uuid='+focused_inputs[i].uuid+']').length){
							changed_value = turnaround.find('.edit-field textarea[data-uuid='+focused_inputs[i].uuid+']').val();
							entry_uuid = turnaround.find('.edit-field textarea[data-uuid='+focused_inputs[i].uuid+']').data('entryuuid');
							attribute_id = turnaround.find('.edit-field textarea[data-uuid='+focused_inputs[i].uuid+']').data('uuid');
						} else {
							changed_value = turnaround.find('.edit-field input[data-uuid='+focused_inputs[i].uuid+']').val();
							entry_uuid = turnaround.find('.edit-field input[data-uuid='+focused_inputs[i].uuid+']').data('entryuuid');
							attribute_id = turnaround.find('.edit-field input[data-uuid='+focused_inputs[i].uuid+']').data('uuid');
						}

						//turnaround_changes.push({ uuid: entry_uuid, turnaround: turnaround_id, value: changed_value, attribute: attribute_id, user: user_uuid });
						turnaround_changes.push(attribute_id + ';' + changed_value);

						turnaround.find('.attribute-current[data-uuid='+focused_inputs[i].uuid+']').text(changed_value);
					} else if(focused_inputs[i].type === 'select'/* && turnaround.find('.edit-field select[data-uuid='+focused_inputs[i].uuid+']').val() && turnaround.find('.edit-field select[data-uuid='+focused_inputs[i].uuid+']').val() !== 'Tyhjä'*/){

						if(turnaround.find('.edit-field select[data-uuid='+focused_inputs[i].uuid+']').val() && turnaround.find('.edit-field select[data-uuid='+focused_inputs[i].uuid+']').val() !== 'Tyhjä'){
							changed_value = turnaround.find('.edit-field select[data-uuid='+focused_inputs[i].uuid+'] option:selected').val();
						} else {
							changed_value = '';
						}

						entry_uuid = turnaround.find('.edit-field select[data-uuid='+focused_inputs[i].uuid+']').data('entryuuid');
						attribute_id = turnaround.find('.edit-field select[data-uuid='+focused_inputs[i].uuid+']').data('uuid');

						//turnaround_changes.push({ uuid: entry_uuid, turnaround: turnaround_id, value: changed_value, attribute: attribute_id, user: user_uuid });
						turnaround_changes.push(attribute_id + ';' + changed_value);

						turnaround.find('.attribute-current[data-uuid='+focused_inputs[i].uuid+']').text(changed_value);
					} else if(focused_inputs[i].type === 'radio') {
						changed_value = turnaround.find('.edit-field input[data-uuid='+focused_inputs[i].uuid+']:checked').length ? turnaround.find('.edit-field input[data-uuid='+focused_inputs[i].uuid+']:checked').val() : '';
						entry_uuid = turnaround.find('.edit-field input[data-uuid='+focused_inputs[i].uuid+']').data('entryuuid');
						attribute_id = turnaround.find('.edit-field input[data-uuid='+focused_inputs[i].uuid+']').data('uuid');

						//turnaround_changes.push({ uuid: entry_uuid, turnaround: turnaround_id, value: changed_value, attribute: attribute_id, user: user_uuid });
						turnaround_changes.push(attribute_id + ';' + changed_value);

						if(changed_value === '1') {
							changed_value = 'Yes';
						} else if(changed_value === '0') {
							changed_value = 'No';
						}
						turnaround.find('.attribute-current[data-uuid='+focused_inputs[i].uuid+']').text(changed_value);

					} else if (focused_inputs[i].type === 'number') {
						changed_value = turnaround.find('.edit-field input[data-uuid='+focused_inputs[i].uuid+']').val();
						entry_uuid = turnaround.find('.edit-field input[data-uuid='+focused_inputs[i].uuid+']').data('entryuuid');
						attribute_id = turnaround.find('.edit-field input[data-uuid='+focused_inputs[i].uuid+']').data('uuid');

						//turnaround_changes.push({ uuid: entry_uuid, turnaround: turnaround_id, value: changed_value, attribute: attribute_id, user: user_uuid });
						turnaround_changes.push(attribute_id + ';' + changed_value);

						turnaround.find('.attribute-current[data-uuid='+focused_inputs[i].uuid+']').text(changed_value);
					}

					turnaround.find('.attribute-current[data-uuid='+focused_inputs[i].uuid+']').addClass('saving');
				}
			}

			if(turnaround_id && window.user.uuid && turnaround_changes.length > 0){
				turnaround.addClass('saving');

				$.ajax({
					url: '/stage-ajax/turnaroundSaveChanges/',
					type: 'GET',
					data: {
						turnaround_changes: turnaround_changes,
						turnaround: turnaround_id,
						user: user_uuid
					},
				})
				.done(function(result) {
					// Saving animation
					if (result.errors.length > 0) {
						showNotification(result.errors[0]);
						turnaround.find('.deleted-text').text( result.errors[0] );
					} else {
						turnaround.addClass('saved');
						turnaround.find('.attribute-current.saving').removeClass('saving');
						setTimeout(function(){
							turnaround.find('.edit-controls .edit').find('.saving-animation').fadeOut(400, function(){
								turnaround.removeClass('saving').removeClass('saved');
								turnaround.find('.edit-controls .edit').find('.saving-animation').prop('style', '');
							});
						}, 3000);

						self._inputEdit(null, 'clear'); // Clear editing data
						self._getItemContent(turnaround_id, turnaround); //Get item contents

						if(turnaround.find('.edit-field #field-actype').val()){
							turnaround.find('.item-name .archive-container .archive-buttons').fadeIn();
							turnaround.find('.missing_info_container').remove();
							turnaround.find('.item-handle').removeClass('missing_info');
						} else {
							turnaround.find('.item-handle').addClass('missing_info');

							if(validity == 'invalid'){
								turnaround.find('.validity').addClass('invalid');
								//turnaround.find('.item-name .archive-container .archive-buttons').fadeIn(200);
							} else {
								turnaround.find('.validity').removeClass('invalid');

								if(!turnaround.find('.edit-field #field-actype').val()){
									//turnaround.find('.item-name .archive-container .archive-buttons').fadeOut(200);
								}
							}
						}
					}

					var validity = turnaround.find('.validity .edit-validity').attr('data-validity');


				})
				.fail(function(jqXHR, textStatus) {
					// Revert changes
					console.log('jqXHR:');
					console.log(jqXHR);
					console.log('textStatus:');
					console.log(textStatus);
					turnaround.find('.attribute-current.saving').removeClass('saving');
					var prev_values = window.turnaround.original_values;
					for (i = 0; i < prev_values.length ;i++) {
						if(prev_values[i].uuid){
							if(prev_values[i].type === 'text'){
								turnaround.find('.edit-field input[type=text][data-uuid='+prev_values[i].uuid+'], .item .edit-field input[type=number][data-uuid='+prev_values[i].uuid+'], .item .edit-field textarea[data-uuid='+prev_values[i].uuid+']').val(prev_values[i].value);
							} else if(prev_values[i].type === 'select') {
								turnaround.find('.edit-field select[data-uuid='+prev_values[i].uuid+'] option').prop('selected', false);
								turnaround.find('.edit-field select[data-uuid='+prev_values[i].uuid+'] option').each(function(k,v) {
									if($(this).val() === prev_values[i].value) {
										$(this).prop('selected', true);
									}
								});
							} else if(prev_values[i].type === 'radio') {
								if(prev_values[i].value){
									turnaround.find('.edit-field input[type=radio][data-uuid='+prev_values[i].uuid+'][value='+prev_values[i].value+']').prop('checked', true);
								} else {
									turnaround.find('.edit-field input[type=radio][data-uuid='+prev_values[i].uuid+']').prop('checked', false);
								}
							}
						}
					}

					var focused_inputs = window.turnaround.focused_inputs;
					for (i = 0; i < focused_inputs.length ;i++) {
						var changed_value = '';

						if(focused_inputs[i]){
							if(focused_inputs[i].type === 'text'){
								changed_value = turnaround.find('.edit-field input[data-uuid='+focused_inputs[i].uuid+']').val();

								turnaround.find('.attribute-current[data-uuid='+focused_inputs[i].uuid+']').text(changed_value);
							} else if(focused_inputs[i].type === 'select' && turnaround.find('.edit-field select[data-uuid='+focused_inputs[i].uuid+']').val() && turnaround.find('.edit-field select[data-uuid='+focused_inputs[i].uuid+']').val() !== 'Tyhjä'){
								changed_value = turnaround.find('.edit-field select[data-uuid='+focused_inputs[i].uuid+'] option:selected').text();

								turnaround.find('.attribute-current[data-uuid='+focused_inputs[i].uuid+']').text(changed_value);
							} else if(focused_inputs[i].type === 'radio') {
								changed_value = turnaround.find('.edit-field input[data-uuid='+focused_inputs[i].uuid+']:checked').length ? turnaround.find('.edit-field input[data-uuid='+focused_inputs[i].uuid+']:checked').val() : '';

								if(changed_value === '1') {
									changed_value = 'Yes';
								} else if(changed_value === '0') {
									changed_value = 'No';
								}
								turnaround.find('.attribute-current[data-uuid='+focused_inputs[i].uuid+']').text(changed_value);
							}
						}
					}

					// Saving animation
					turnaround.addClass('saving-failed');
					turnaround.find('.attribute-current.saving').removeClass('saving');
					setTimeout(function(){
						turnaround.find('.edit-controls .edit').find('.saving-animation').fadeOut(400, function(){
							turnaround.removeClass('saving').removeClass('saving-failed');
							turnaround.find('.edit-controls .edit').find('.saving-animation').prop('style', '');
						});
					}, 3000);

					self._inputEdit(null, 'clear'); // Clear editing data

				});
			}
		}
	},
	_itemActions: function() {
		// General actions of turnarounds and contents

		var self = this;

		$('.duplicate-icon').unbind().click(function(){
			var $current_element = $(this);
			var $duplicate_element = $('#duplicate-' + $current_element.data('target'));

			if(!$current_element.hasClass('active')){
				$('.duplicate-icon').removeClass('active');
				$('#duplicate-connector').hide();
				$('.item').removeClass('duplicate-info');

				$current_element.parent().addClass('duplicate-info');

				var duplicate_icon_positions = [];

				setTimeout(function(){
					$current_element.addClass('active');

					if($duplicate_element.length){
						duplicate_icon_positions.push($current_element.offset().top);
						duplicate_icon_positions.push($duplicate_element.offset().top);

						var duplicate_lower = Math.max(...duplicate_icon_positions);
						var duplicate_higher = Math.min(...duplicate_icon_positions);

						$duplicate_element.addClass('active');

						$('#duplicate-connector').fadeIn(400);
						$('#duplicate-connector').height(duplicate_lower - duplicate_higher);
						$('#duplicate-connector').css('top', duplicate_higher + 6 + 'px');
					}
				},200);
			} else {
				$('.duplicate-icon').removeClass('active');
				$('#duplicate-connector').hide();
				$('.item').removeClass('duplicate-info');
			}
		});

		$(window).resize(function(){
			if($('#duplicate-connector:visible').length && $('.duplicate-icon.active').length){
				var $current_element = $($('.duplicate-icon.active')[0]);
				var $duplicate_element = $($('.duplicate-icon.active')[1]);

				var duplicate_icon_positions = [];

				duplicate_icon_positions.push($current_element.offset().top);
				duplicate_icon_positions.push($duplicate_element.offset().top);

				var duplicate_lower = Math.max(...duplicate_icon_positions);
				var duplicate_higher = Math.min(...duplicate_icon_positions);

				$('#duplicate-connector').height(duplicate_lower - duplicate_higher);
				$('#duplicate-connector').css('top', duplicate_higher + 6 + 'px');
			} else {
				$('.duplicate-icon').removeClass('active');
				$('#duplicate-connector').hide();
				$('.item').removeClass('duplicate-info');
			}
		});

		// Delete turnaround
		$('.item-list .item').find('.delete').unbind().click(function(e){
			var $el = $(this);
			if($el[0] === e.target){
				$el.find('.delete-container').toggleClass('active');
			}
		});

		$('.item-list .item .delete').find('.cancel-deletion').unbind().click(function(){
			var $el = $(this);
			$el.parents('.item').find('.delete-container').removeClass('active');
		});

		$('.item-list .item .delete').find('.confirm-deletion').unbind().click(function(){
			var $el = $(this);
			$el.parents('.item').find('.delete-container').removeClass('active');
			self._deleteTurnaround($(this).parents('.item'));
		});

		// Row content edit
		$('.item-list .item').find('.edit').unbind().click(function(){
			var $el = $(this);

			$el.parents('.item').find('.delete-container').removeClass('active');

			$el.parents('.item').removeClass('saving').removeClass('saved');
			$el.parents('.item').addClass('edit');

			$el.parents('.item').find('.edit-field').find('input[type=text], input[type=number], textarea, input[type=date], input[type=time], select').on('input', function(){
				self._inputEdit($(this));
			});

			$el.parents('.item').find('.edit-field').find('input[type=text], input[type=number], textarea, input[type=date], input[type=time], select, button').focusin(function(){
				self._inputEdit($(this));
			});

			$el.parents('.item').find('.edit-field').find('input[type=text], input[type=number], textarea, input[type=date], input[type=time], select, input[type=radio]').change(function(){
				self._inputEdit($(this));
			});

			$el.parents('.item').find('.edit-field').find('input[type=text], input[type=number], textarea, input[type=date], input[type=time], select, input[type=radio], button').mousedown(function(){
				self._inputEdit($(this));
			});

			$el.parents('.item').find('.edit-field').find('input[type=radio] + label').mousedown(function(){
				self._inputEdit($(this));
			});
		});

		// Row content edit cancel
		$('.item-list .item').find('.cancel').unbind().click(function(){
			var $el = $(this);
			$el.parents('.item').removeClass('edit');

			// Revert changes
			var prev_values = window.turnaround.original_values;
			for (var i = 0; i < prev_values.length ;i++) {
				if(prev_values[i].uuid){
					if(prev_values[i].type === 'text'){
						$el.parents('.item').find('.edit-field input[type=text][data-uuid='+prev_values[i].uuid+'], .item .edit-field input[type=number][data-uuid='+prev_values[i].uuid+'], .item .edit-field textarea[data-uuid='+prev_values[i].uuid+']').val(prev_values[i].value);
					} else if(prev_values[i].type === 'select') {
						$el.parents('.item').find('.edit-field select[data-uuid='+prev_values[i].uuid+'] option').prop('selected', false);
						$el.parents('.item').find('.edit-field select[data-uuid='+prev_values[i].uuid+'] option').each(function(k,v) {
							if($(this).val() === prev_values[i].value) {
								$(this).prop('selected', true);
							}
						});
					} else if(prev_values[i].type === 'radio') {
						if(prev_values[i].value){
							$el.parents('.item').find('.edit-field input[type=radio][data-uuid='+prev_values[i].uuid+'][value='+prev_values[i].value+']').prop('checked', true);
						} else {
							$el.parents('.item').find('.edit-field input[type=radio][data-uuid='+prev_values[i].uuid+']').prop('checked', false);
						}
					} else if(prev_values[i].type === 'timestamp') {
						//$el.parents('.item').find('.edit-field input.datetime[data-uuid='+prev_values[i].uuid+']').parent().find('input').val(prev_values[i].value);
					}
				}
			}

			self._inputEdit(null, 'clear'); // Clear editing data

			$('.edit-field input[type=date], .edit-field input[type=time]').each(function() {
				self._handleErrorIndicators($(this), true);
			});
		});

		// Row content edit save
		$('.item-list .item').find('.save').unbind().click(function(){
			var $el = $(this);

			self._saveEditedTurnaround($el.parents('.item'));

			$('.edit-field input[type=date], .edit-field input[type=time]').each(function() {
				self._handleErrorIndicators($(this), true);
			});
		});

		// Click turnaround to expand and get contents
		var disabled = false;
		$('.item-handle').unbind().click(function(e){
			var $el = $(this);
			if(!$el.parent().hasClass('deleted') && e.target === this || e.target === $el.children('.item-name')[0] || e.target === $el.find('.item-name span')[0] || e.target === $el.find('.item-name span')[1]){

				if($el.data('loaded') === 'no'){
					$el.parent().find('.item-content-loader').html('<div class="lds-ripple"><div></div><div></div></div>');
				}

				if($el.parents('.turnaround-container').find('.item-handle.active').length && !$el.hasClass('active')){

					$el.parents('.turnaround-container').find('.delete-container').removeClass('active');
					$el.parents('.turnaround-container').find('.item').removeClass('edit');
					$el.parents('.turnaround-container').find('.item-content').slideUp();
					$el.parents('.turnaround-container').find('.item-content-loader').slideUp();

					self._inputEdit(null, 'clear'); // Clear editing data

					disabled = true;
					setTimeout(function(){
						$el.parents('.turnaround-container').find('.item-handle').removeClass('active');

						$el.addClass('active');
						setTimeout(function(){
							if($el.data('loaded') === 'yes'){
								$el.parent().find('.item-content').slideDown();
								self._getItemObject($el.data('turnaround'), $el.parent());
								$el.parent().find('.item-content-item').append('<span class="update-checker">Checking if data has been updated</span>');
							} else if($el.data('loaded') === 'no') {
								$el.parent().find('.item-content-loader').slideDown();
								self._getItemContent($el.data('turnaround'), $el.parent());
							}
							disabled = false;
						}, 100);
					}, 100);
				} else {
					if(disabled === false){
						disabled = true;
						if(!$el.hasClass('active')){
							$el.addClass('active');

							setTimeout(function(){
								if($el.data('loaded') === 'yes'){
									$el.parent().find('.item-content').slideDown();
									self._getItemObject($el.data('turnaround'), $el.parent());
									$el.parent().find('.item-content-item').append('<span class="update-checker">Checking if data has been updated</span>');
								} else if($el.data('loaded') === 'no') {
									$el.parent().find('.item-content-loader').slideDown();
									self._getItemContent($el.data('turnaround'), $el.parent());
								}
								disabled = false;
							}, 100);
						} else {
							$el.parents('.turnaround-container').find('.delete-container').removeClass('active');
							$el.parents('.item').removeClass('edit');
							$el.parent().find('.item-content').slideUp();
							$el.parent().find('.item-content-loader').slideUp();

							self._inputEdit(null, 'clear'); // Clear editing data

							setTimeout(function(){
								$el.removeClass('active');
								disabled = false;
							}, 100);
						}
					}
				}
			}

			if($el.parent().hasClass('deleted')){
				$el.parent().find('.item-content').slideToggle();
				$el.toggleClass('active');
			}
		});

		$('.item .validity .edit-validity').find('.validity-button').click(function(){
			var $self = $(this);

			$self.parent().children('.validity-button').removeClass('active');
			$self.addClass('active');
			$self.parent().attr('data-validity', $self.attr('data-value'));

			window.turnaround.validityChanged = true;
		});

		// Refresh turnaround content
		/*$('.item .edit-controls .refresh-button').click(function(){
			var $el = $(this);
			$el.parents('.item-content').append('<div class="item-refresher"><div class="lds-ripple"><div></div><div></div></div></div>');
			self._getItemContent($el.parents('.item').find('.item-handle').data('turnaround'), $el.parents('.item'));
		});*/
	},
	_deleteTurnaround: function(turnaround){
		var turnaround_id = turnaround.find('.item-handle').data('turnaround');

		turnaround.parents('.turnaround-container').find('.item-content').slideUp();
		turnaround.parents('.turnaround-container').find('.item-content-loader').slideUp();
		turnaround.addClass('deleted').removeClass('saving').removeClass('saved').removeClass('edit');
		turnaround.find('.item-handle').removeClass('active');
		turnaround.find('.deleted-text').addClass('deleting').text('DELETING');
		turnaround.find('.archive-container').remove();
		turnaround.find('.edit-controls > *').remove();

		var data = {
			turnaround: turnaround_id,
			clientJSVersion: clientJSVersion,
			'stage-language': 'en'
		};

		$.ajax('/stage-ajax/deleteTurnaround/', {
			method: 'DELETE',
			data: data,
			success: function(data) {
				console.log('Turnaround deleted: ' + turnaround_id);
				console.log(data);
				turnaround.find('.deleted-text').removeClass('deleting').text('DELETED');
			},
			error: function(jqXHR) {
				console.log(jqXHR.responseText);
				turnaround.find('.deleted-text').removeClass('deleting').text('DELETE ERROR');
			}
		});
	},
	_archive: function(){

		//Show archive option
		$('button.archive').click(function(e){
			//e.preventDefault();
			var id = $(this).data('turnaround');
			//console.log(id);
			$(this).removeClass('active');
			$('.confirm-archive.arch-' + id + ', .cancel-archive.arch-'+id).addClass('active');
		});

		//Cancel
		$('button.cancel-archive').click(function(e){
			e.preventDefault();
			var id = $(this).data('turnaround');
			$('.arch-'+id).removeClass('active');
			$('.archive.arch-'+id).addClass('active');
		});

		// Archive turnaround
		$('.confirm-archive').click(function() {
			var $archiveButton = $(this);
			var turnaround = $archiveButton.data('turnaround');
			var $turnaroundItem = $('.item-handle[data-turnaround='+ turnaround +']');
			var $error = $(this).closest('.error');
			var $archiveContainer = $(this).parent();

			$archiveContainer.html(STAGE_TRANSLATION.ARCHIVING);
			//$turnaround.prop('disabled', true);

			var archivingReady = {};

			archivingReady[turnaround] = false;

			//$error.empty();

			var data = {
				turnaround: turnaround,
				archiver: window.username,
				//clientJSVersion: clientJSVersion,
				'stage-language': 'en'
			};

			$turnaroundItem.parents('.turnaround-container').find('.item-handle').removeClass('active');
			$turnaroundItem.parents('.turnaround-container').find('.delete-container').removeClass('active');
			$turnaroundItem.parents('.turnaround-container').find('.item').removeClass('edit');
			$turnaroundItem.parents('.turnaround-container').find('.item-content-loader').slideUp(200);
			$turnaroundItem.parents('.turnaround-container').find('.item-content').slideUp(200);

			$.post('/stage-ajax/archive', data).done(function(serviceData) {
				$turnaroundItem.html(STAGE_TRANSLATION.ARCHIVING_SUCCESSFUL);
				setTimeout(function(){
					$turnaroundItem.parent().slideUp(200, function() {
						$turnaroundItem.parent().remove();
						//DTable.draw();
					});
				}, 2000);
			}).fail(function(jqXHR, textStatus, errorThrown) {
				if (jqXHR.status !== 200) {
					$error.html(STAGE_TRANSLATION.NETWORK_ERROR);
				} else {
					$error.html(STAGE_TRANSLATION.UNKNOWN_ERROR);
				}

				archivingReady[turnaround] = true;
			}).complete(function(jqXHR, textStatus) {
				// Check if every archiving is ready
				archivingReady[turnaround] = true;
				var allArchivingIsReady = true;

				$.each(archivingReady, function(turnaround, isReady) {
					if (!isReady) {
						allArchivingIsReady = false;
						return false;
					}
				});

				/*if (allArchivingIsReady) {
					// Everything is ready! Enable archive button again and return to normal
					$archive.html(STAGE_TRANSLATION.ARCHIVE);
					$archive.prop('disabled', false);
				}*/

			});

		});

	},
	init: function() {
		this._headerActions();
		this._collapseControls();
		this._itemActions();
		this._loadRows();
		this._archive();

	}
};

module.exports = ops;
